/**
 * @desc 新增主要物料设置
 */

import * as defs from '../../baseClass';
import { defHttp } from 'hailuo-http';
export interface Params {}

export function request(
  data: defs.SettingMaterialRequest,
): Promise<defs.StandardReturn<void>> {
  return defHttp.post({
    url: '/web/setting/material/add',
    data,
  });
}

export function mock(
  data: defs.SettingMaterialRequest,
): Promise<defs.StandardReturn<void>> {
  return defHttp.post({
    url: '/mock/web/setting/material/add',
    data,
  });
}
